<app-loader *ngIf="isLoading"></app-loader>
<ng-template #progressDots>
  <span class="loading-dots" aria-hidden="true"><span>.</span><span>.</span><span>.</span></span>
</ng-template>
<div class="compile-container">
  <div class="review-top">
    <div class="upload-card-head">
      <div class="title-row">
        <h2>{{ labels.COMPILE_EXPORT.EYEBROW }}</h2>
        <h2 class="screen-title-green">{{ labels.COMPILE_EXPORT.CCOMPILE_EXPORT }}</h2>
      </div>
    </div>
    <div class="stepper-row">
      <!-- Stepper: review is behind us, approval is the current step -->
      <div class="custom-stepper">
        <div class="step done">
          <div class="circle"><mat-icon class="initial-center">check</mat-icon></div>
          <div class="label">{{ labels.COMMON.STEPS.INITIATE }}</div>
        </div>
        <div class="line"></div>
        <div class="step done">
          <div class="circle"><mat-icon class="initial-center">check</mat-icon></div>
          <div class="label">{{ labels.COMMON.STEPS.ANALYZED }}</div>
        </div>
        <div class="line"></div>
        <div class="step done">
          <div class="circle"><mat-icon class="initial-center">check</mat-icon></div>
          <div class="label">{{ labels.COMMON.STEPS.REVIEW }}</div>
        </div>
        <div class="line"></div>
        <div class="step active">
          <div class="circle">
            <div class="initial-center">4</div>
          </div>
          <div class="label">{{ labels.COMMON.STEPS.APPROVED }}</div>
        </div>
      </div>
    </div>
  </div>

  @if (isLoaded()) {
    <!-- Report header: title, metadata, and chips in a single row (same pattern as review-refine). -->
    <div class="compile-head">
      <div class="compile-identity report-meta report-meta-single-row">
        <h2 class="report-title">{{ header()?.reportName }}</h2>
        @if (header()?.projectId) {
          <span class="meta-pair">
            <span class="meta-label">{{ labels.REVIEW_REFINE.PROJECT_ID }}</span>
            {{ header()?.projectId }}
          </span>
        }
        @if (header()?.owner?.displayName) {
          <span class="meta-pair">
            <span class="meta-label">{{ labels.REVIEW_REFINE.OWNER }}</span>
            {{ header()?.owner?.displayName }}
          </span>
        }
        @if (header()?.dateCreated) {
          <span class="meta-pair">
            <span class="meta-label">{{ labels.REVIEW_REFINE.CREATED }}</span>
            {{ header()?.dateCreated | date: 'dd MMM yyyy' }}
          </span>
        }
        
      </div>
    </div>

    <!-- Undecided changes are excluded server-side; say so before anything is generated. -->
    @if (decisions().pending > 0) {
      <p class="pending-warning">
        <mat-icon class="warn-icon">warning</mat-icon>
        {{ decisions().pending }} {{ labels.COMPILE_EXPORT.PENDING_WARNING }}
      </p>
    }

    <div class="compile-layout">
      <!-- Attachment order & divider names -->
      <section class="order-card">
        <header class="order-head">
          <div>
            <h3 class="order-title">{{ labels.COMPILE_EXPORT.ORDER_TITLE }}</h3>
            <p class="order-hint">{{ labels.COMPILE_EXPORT.ORDER_HINT }}</p>
          </div>
        </header>

        <div class="order-item order-item--fixed">
          <span class="item-position">1</span>
          <mat-icon class="item-handle item-handle--fixed">description</mat-icon>
          <div class="item-text">
            <span class="item-name">{{ header()?.reportName || labels.COMPILE_EXPORT.ORDER_TITLE }}</span>
          </div>
          <span class="badge">Body</span>
        </div>

        @if (hasDocuments()) {
          <ul class="order-list" cdkDropList (cdkDropListDropped)="onDrop($event)">
            @for (document of documents(); track document.fileId; let i = $index) {
              <li class="order-item" cdkDrag>
                <span class="item-position">{{ i + 2 }}</span>
                <mat-icon class="item-handle" cdkDragHandle>drag_indicator</mat-icon>
                <div class="item-text">
                  <span class="item-name">{{ document.originalName }}</span>
                  @if (fileKind(document)) {
                    <span class="item-sub">{{ fileKind(document) }}</span>
                  }
                </div>
                <span class="divider-name" [title]="labels.COMPILE_EXPORT.DIVIDER_READONLY">
                  {{ labels.COMPILE_EXPORT.DIVIDER_PREFIX }} "{{ dividerName(document) }}"
                </span>
                <div class="item-move">
                  <button
                    type="button"
                    class="move-btn"
                    [disabled]="i === 0"
                    [attr.aria-label]="labels.COMPILE_EXPORT.MOVE_UP"
                    [title]="labels.COMPILE_EXPORT.MOVE_UP"
                    (click)="move(i, -1)"
                  >
                    <mat-icon>arrow_upward</mat-icon>
                  </button>
                  <button
                    type="button"
                    class="move-btn"
                    [disabled]="i === documents().length - 1"
                    [attr.aria-label]="labels.COMPILE_EXPORT.MOVE_DOWN"
                    [title]="labels.COMPILE_EXPORT.MOVE_DOWN"
                    (click)="move(i, 1)"
                  >
                    <mat-icon>arrow_downward</mat-icon>
                  </button>
                </div>
              </li>
            }
          </ul>
        } @else {
          <p class="empty-state">{{ labels.COMPILE_EXPORT.NO_DOCUMENTS }}</p>
        }

        @if (isDirty()) {
          <p class="unsaved-note">{{ labels.COMPILE_EXPORT.UNSAVED_ORDER }}</p>
        }
      </section>

      <!-- Approval + export -->
      <aside class="approval-card">
        <div class="export-actions">
          <button
            type="button"
            class="aecom_btn"
            [disabled]="isExportBusy()"
            (click)="previewReport()"
          >
            @if (isPreviewing()) {
              <span>{{ labels.COMPILE_EXPORT.BUTTON.PREVIEWING }}</span>
              <ng-container [ngTemplateOutlet]="progressDots"></ng-container>
            } @else {
              {{ labels.COMPILE_EXPORT.BUTTON.PREVIEW }}
            }
          </button>
          <button
            type="button"
            class="aecom_btn--solid"
            [disabled]="isExportBusy()"
            (click)="generateConsolidatedPdf()"
          >
            @if (exporting() === 'pdf') {
              <span>{{ labels.COMPILE_EXPORT.BUTTON.EXPORTING }}</span>
              <ng-container [ngTemplateOutlet]="progressDots"></ng-container>
            } @else if (downloading() === 'pdf') {
              <span>Downloading</span>
              <ng-container [ngTemplateOutlet]="progressDots"></ng-container>
            } @else {
              {{ labels.COMPILE_EXPORT.BUTTON.GENERATE_PDF }}
            }
          </button>
          <button
            type="button"
            class="aecom_btn"
            [disabled]="isExportBusy()"
            (click)="downloadUpdatedDocx()"
          >
            @if (exporting() === 'docx') {
              <span>{{ labels.COMPILE_EXPORT.BUTTON.EXPORTING }}</span>
              <ng-container [ngTemplateOutlet]="progressDots"></ng-container>
            } @else if (downloading() === 'docx') {
              <span>Downloading</span>
              <ng-container [ngTemplateOutlet]="progressDots"></ng-container>
            } @else {
              {{ labels.COMPILE_EXPORT.BUTTON.DOWNLOAD_DOCX }}
            }
          </button>
        </div>
      </aside>
    </div>

    <div class="page-action">
      <button type="button" class="aecom_btn" (click)="close()">{{ labels.COMMON.CLOSE }}</button>
      <button type="button" class="aecom_btn" (click)="backToReview()">
        {{ labels.COMPILE_EXPORT.BUTTON.BACK_TO_REVIEW }}
      </button>
    </div>
  }
</div>
